import MuiAutocomplete, {
  autocompleteClasses,
} from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';

import styled from 'shared/utils/styled';

export const StyledAutocomplete = styled(MuiAutocomplete)(({ theme }) => ({
  [`&.${autocompleteClasses.root}`]: {
    [`& .${autocompleteClasses.inputRoot}`]: {
      borderBottom: '1px solid rgba(34, 64, 96, 0.2)',
      [`& .${autocompleteClasses.input}`]: {
        height: 'auto',
        minHeight: 24,
        font: `400 ${theme.typography.pxToRem(15)} NeoSansStd`,
        color: theme.palette.primary.main,
      },
    },

    [`& .${autocompleteClasses.popupIndicator}`]: {
      padding: 3,
      backround: 'rgb(240, 243, 247)',
      color: theme.palette.primary.main,
    },

    [`& .${autocompleteClasses.clearIndicator}`]: {
      padding: 3,
      '& > svg': {
        fontSize: 19,
        color: theme.palette.primary.main,
      },
    },
  },
})) as typeof MuiAutocomplete;

export const StyledPopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.paper}`]: {
    borderRadius: 0,
  },
  [`& .${autocompleteClasses.groupLabel}`]: {
    position: 'static',
    fontFamily: 'NeoSansStd',
    fontSize: 15,
    lineHeight: '40px',
    background: 'transparent',
  },
  [`& .${autocompleteClasses.listbox}`]: {
    background: 'rgb(249, 249, 249)',
  },
  [`& .${autocompleteClasses.option}`]: {
    padding: 8,
    font: `400 ${theme.typography.pxToRem(15)} NeoSansStd`,
    color: theme.palette.primary.main,
  },
}));
